import { Controller } from "@hotwired/stimulus"

// Pure Tailwind sidebar dropdown controller - no Bootstrap dependencies
export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    console.log("Sidebar dropdown controller connected", this.element);
    // Make sure menus are hidden initially
    if (this.hasMenuTarget) {
      console.log("Hiding menu on connect");
      this.hide();
    } else {
      console.log("No menu target found on connect");
    }
  }

  toggle(event) {
    console.log("Toggle called", this.element);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Check current state using the show class
    const isCurrentlyOpen = this.hasMenuTarget && this.menuTarget.classList.contains("show");

    console.log("Menu currently open?", isCurrentlyOpen);

    // Close other open dropdowns first
    this.closeOtherDropdowns();

    // Toggle this dropdown
    if (isCurrentlyOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    console.log("Show menu called");
    if (this.hasMenuTarget) {
      // Show the menu - handle both hidden and tw-hidden cases
      this.menuTarget.classList.remove("hidden");
      this.menuTarget.classList.remove("tw-hidden");
      // ADD the show class which is what the CSS expects
      this.menuTarget.classList.add("show");
      // Remove inline display style to let CSS take over
      this.menuTarget.style.removeProperty("display");

      // Update the icon
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("fa-chevron-down");
        this.iconTarget.classList.add("fa-chevron-up");
      }

      console.log("Menu display after show:", this.menuTarget.classList.contains("show"), window.getComputedStyle(this.menuTarget).display);
    } else {
      console.warn("No menu target found for show()");
    }
  }

  hide() {
    console.log("Hide menu called");
    if (this.hasMenuTarget) {
      // Hide the menu - handle both hidden and tw-hidden cases
      this.menuTarget.classList.add("tw-hidden");
      // REMOVE the show class which is what the CSS expects
      this.menuTarget.classList.remove("show");
      // Remove inline display style to let CSS take over
      this.menuTarget.style.removeProperty("display");

      // Update the icon
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("fa-chevron-down");
        this.iconTarget.classList.remove("fa-chevron-up");
      }
    } else {
      console.warn("No menu target found for hide()");
    }
  }

  // Close all other open dropdowns
  closeOtherDropdowns() {
    const allDropdowns = this.application.controllers.filter(
      controller => controller.context.identifier === 'sidebar-dropdown-pure' && controller !== this
    )

    allDropdowns.forEach(controller => {
      if (controller.isOpen && controller.isOpen()) {
        controller.hide()
      }
    })
  }

  isOpen() {
    return this.hasMenuTarget && this.menuTarget.classList.contains("show")
  }
}